<div class="searchInputAutocomplete__bg" [class.open]="viewAutocomplete" (click)="closeView()"></div>

@if (isMobile) {
  <app-drop-down-view
    [defaultState]="viewAutocomplete"
    [closeAction]="closeAction"
    [title]="title"
    (closeEvent)="closeView()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="autocompleteContent;"></ng-container>
    </ng-container>
  </app-drop-down-view>
} @else {
  <ng-container *ngTemplateOutlet="autocompleteContent;"></ng-container>
}

<ng-template #autocompleteContent>
  <div class="searchInputAutocomplete__cont" [class.open]="viewAutocomplete">
    <div class="searchInputAutocomplete__input-place">
      <app-ds-input-text
        [filled]="true"
        [staticFilled]="true"
        [autofocus]="viewAutocomplete"
        [icon]="inputPlaceListIcon"
        [label]="inputPlaceListLabel"
        [value]="query"
        [placeholder]="inputPlaceListPlaceholder"
        (changeEvent)="setQuery.emit($event)">
      </app-ds-input-text>
    </div>
    <ng-container *ngTemplateOutlet="autocomplteBody;"></ng-container>
  </div>
</ng-template>

<ng-template #autocomplteBody>
  <div class="searchInputAutocomplete__autocomplete">
    @if (!isLoadingAutocompletePlaces) {
      @if (!mergeAirportsAndCities) {
        @if (airportsAreEnabled && cityAndAirportsAutocomplete?.airports?.length) {
          <ul class="searchInputAutocomplete__autocomplete-airports-and-cities">
            <app-ds-typography
              [text]="'SEARCH_MODULE.AIRPORTS' | transloco"
              [fontFamily]="fontFamily.SemiBold"
              [size]="fontSize.XXS"
              [ellipsis]="true"
              [color]="fontColor">
            </app-ds-typography>
            <li *ngFor="let place of getFilteredList(autocompleteType.Airports); index as placeId" [ngClass]="{ 'searchInputAutocomplete__autocomplete--lastItem': isLastItemVisible(autocompleteType.Airports, placeId) }">
              <div class="autocomplete-flex-cont" (click)="selectAirportOrCity(place, true)">
                <ng-container *ngTemplateOutlet="airportCardInfo; context: { place: place, icon: icons.Flights, isBold: true }"></ng-container>
              </div>
            </li>
            <ng-container *ngTemplateOutlet="collapsableControl; context: { type: autocompleteType.Airports }"></ng-container>
          </ul>
        }
        @if (cityAndAirportsAutocomplete?.cities?.length) {
          <ul class="searchInputAutocomplete__autocomplete-airports-and-cities">
            @if (airportsAreEnabled) {
              <app-ds-typography
                [text]="'SEARCH_MODULE.PLACES' | transloco"
                [fontFamily]="fontFamily.SemiBold"
                [size]="fontSize.XXS"
                [ellipsis]="true"
                [color]="fontColor">
              </app-ds-typography>
              <app-ds-typography
                [text]="'SEARCH_MODULE.SUBTITLE_PLACES' | transloco"
                [fontFamily]="fontFamily.Regular"
                [size]="fontSize.XXXS"
                [color]="fontColor">
              </app-ds-typography>
            }
            <li *ngFor="let place of getFilteredList(autocompleteType.Cities); index as placeId" [ngClass]="{ 'searchInputAutocomplete__autocomplete--lastItem': isLastItemVisible(autocompleteType.Cities, placeId) }">
              <div class="autocomplete-flex-cont" (click)="selectAirportOrCity(place)">
                <ng-container *ngTemplateOutlet="cityCardInfo; context: { place: place, icon: icons.Location, isBold: true }"></ng-container>
              </div>
            </li>
            <ng-container *ngTemplateOutlet="collapsableControl; context: { type: autocompleteType.Cities }"></ng-container>
          </ul>
        }
      } @else {
        <ng-container *ngTemplateOutlet="mergeAirportsAndCitiesTemplate;"></ng-container>
      }
      @if (hotelAndLocationsAutocomplete?.locations?.length) {
        <ul class="searchInputAutocomplete__autocomplete-locations">
          <li *ngFor="let location of hotelAndLocationsAutocomplete.locations; index as placeId">
            <div class="autocomplete-flex-cont" (click)="selectLocationEvent.emit(location)">
              <div class="searchInputAutocomplete__autocomplete-locations-icon-cont-place">
                <app-ds-icon
                  [icon]="location.TypeIcon"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="searchInputAutocomplete__autocomplete-place-name">
                <div class="searchInputAutocomplete__autocomplete-place-info">
                  <app-ds-typography
                    [text]="location.Name"
                    [fontFamily]="fontFamily.SemiBold"
                    [size]="fontSize.XXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                  <app-ds-typography
                    [text]="fullNameByLocationAutocomplete(location?.NameFull, location?.Name)"
                    [size]="fontSize.XXXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                </div>
              </div>
            </div>
          </li>
        </ul>
      }
      @if (hotelAndLocationsAutocomplete?.hotels?.length) {
        <ul class="searchInputAutocomplete__autocomplete-locations">
          <li *ngFor="let hotel of hotelAndLocationsAutocomplete.hotels; index as placeId">
            <div class="autocomplete-flex-cont" (click)="selectHotelEvent.emit(hotel)">
              <div class="searchInputAutocomplete__autocomplete-locations-icon-cont-place">
                <app-ds-icon
                  [icon]="icons.Hotels"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="searchInputAutocomplete__autocomplete-place-name">
                <div class="searchInputAutocomplete__autocomplete-place-info">
                  <app-ds-typography
                    [text]="hotel.hotel_name"
                    [fontFamily]="fontFamily.SemiBold"
                    [size]="fontSize.XXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                  <app-ds-typography
                    [text]="hotel.address"
                    [size]="fontSize.XXXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                </div>
              </div>
            </div>
          </li>
        </ul>
      }
      @if (activityAndDestinationAutocomplete?.destinations?.length) {
        <ul class="searchInputAutocomplete__autocomplete-locations">
          <app-ds-typography
            [text]="'SEARCH_MODULE.DESTINATIONS' | transloco"
            [fontFamily]="fontFamily.SemiBold"
            [size]="fontSize.XXS"
            [ellipsis]="true"
            [color]="fontColor">
          </app-ds-typography>
          <li *ngFor="let destination of getFilteredList(autocompleteType.Destinations); index as placeId" [ngClass]="{ 'searchInputAutocomplete__autocomplete--lastItem': isLastItemVisible(autocompleteType.Destinations, placeId) }">
            <div class="autocomplete-flex-cont" (click)="selectExtraDestinationEvent.emit(destination)">
              <div class="searchInputAutocomplete__autocomplete-locations-icon-cont-place">
                <app-ds-icon
                  [icon]="icons.Location"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="searchInputAutocomplete__autocomplete-place-name">
                <div class="searchInputAutocomplete__autocomplete-place-info">
                  <app-ds-typography
                    [text]="destination.cityName | capitalizeAll"
                    [fontFamily]="fontFamily.SemiBold"
                    [size]="fontSize.XXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                  <app-ds-typography
                    [text]="fullNameByLocationAutocomplete(destination?.countryName, null)"
                    [size]="fontSize.XXXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                </div>
              </div>
            </div>
          </li>
          <ng-container *ngTemplateOutlet="collapsableControl; context: { type: autocompleteType.Destinations }"></ng-container>
        </ul>
      }
      @if (activityAndDestinationAutocomplete?.activities?.length) {
        <ul class="searchInputAutocomplete__autocomplete-locations">
          <app-ds-typography
            [text]="'SEARCH_MODULE.ACTIVITIES' | transloco"
            [fontFamily]="fontFamily.SemiBold"
            [size]="fontSize.XXS"
            [ellipsis]="true"
            [color]="fontColor">
          </app-ds-typography>
          <li *ngFor="let activity of getFilteredList(autocompleteType.Activities); index as placeId" [ngClass]="{ 'searchInputAutocomplete__autocomplete--lastItem': isLastItemVisible(autocompleteType.Activities, placeId) }">
            <div class="autocomplete-flex-cont" (click)="selectActivityEvent.emit(activity)">
              <div class="searchInputAutocomplete__autocomplete-locations-icon-cont-place">
                <app-ds-icon
                  [icon]="icons.Activities"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="searchInputAutocomplete__autocomplete-place-name">
                <div class="searchInputAutocomplete__autocomplete-place-info">
                  <app-ds-typography
                    [text]="activity.activityName | capitalizeAll"
                    [fontFamily]="fontFamily.SemiBold"
                    [size]="fontSize.XXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                  <app-ds-typography
                    [text]="activity?.cityName + (activity?.countryName ? (activity?.cityName ? ', ' : '') + activity?.countryName : '')"
                    [size]="fontSize.XXXS"
                    [ellipsis]="true"
                    [color]="fontColor">
                  </app-ds-typography>
                </div>
              </div>
            </div>
          </li>
          <ng-container *ngTemplateOutlet="collapsableControl; context: { type: autocompleteType.Activities }"></ng-container>
        </ul>
      }
    } @else {
      <ng-container *ngTemplateOutlet="loader;"></ng-container>
    }
    <app-search-bar-popular-destinations
      [active]="viewAutocomplete"
      [placeType]="placeType"
      [searchType]="searchType"
      (selectPlace)="selectPopularPlace.emit($event)"
      (popularSelected)="popularAmplitudeEvent.emit($event)">
    </app-search-bar-popular-destinations>
  </div>
</ng-template>

<ng-template #airportCardInfo let-place="place" let-icon="icon" let-isBold="isBold">
  <div class="searchInputAutocomplete__autocomplete-locations-icon-cont-place">
    <app-ds-icon
      [icon]="icon"
      [size]="22"
      [color]="iconFillColor.Primary">
    </app-ds-icon>
  </div>
  <div class="searchInputAutocomplete__autocomplete-city-info">
    <ng-container *ngTemplateOutlet="airportPlaceTemplate; context: { placeInfo: place, isBold: isBold }"></ng-container>
  </div>
</ng-template>

<ng-template #cityCardInfo let-place="place" let-icon="icon" let-isBold="isBold">
  <div class="searchInputAutocomplete__autocomplete-locations-icon-cont-place">
    <app-ds-icon
      [icon]="icon"
      [size]="22"
      [color]="iconFillColor.Primary">
    </app-ds-icon>
  </div>
  <div class="searchInputAutocomplete__autocomplete-city-info">
    <ng-container *ngTemplateOutlet="cityPlaceTemplate; context: { place: place, isBold: isBold }"></ng-container>
  </div>
</ng-template>

<ng-template #airportOption let-place="place" let-isBold="isBold">
  <div class="searchInputAutocomplete__autocomplete-place-info">
    <div class="searchInputAutocomplete__autocomplete-place-info-city">
      <app-ds-typography
        [text]="place.related_city + ', ' + place.country"
        [size]="fontSize.XXS"
        [fontFamily]="isBold ? fontFamily.SemiBold : fontFamily.Regular"
        [ellipsis]="true"
        [color]="fontColor">
      </app-ds-typography>
    </div>
    <div class="searchInputAutocomplete__autocomplete-place-info-airport">
      <app-ds-typography
        [text]="place.description"
        [size]="fontSize.XXXS"
        [ellipsis]="true"
        [color]="fontColor">
      </app-ds-typography>
    </div>
  </div>
</ng-template>

<ng-template #airportPlaceTemplate let-placeInfo="placeInfo" let-inCity="inCity" let-isBold="isBold">
  <ng-container *ngIf="!inCity; else airportSubOptionTemplate">
    <ng-container *ngTemplateOutlet="airportOption; context: { place: placeInfo, isBold: isBold }"></ng-container>
  </ng-container>
  <ng-template #airportSubOptionTemplate>
    <ng-container *ngTemplateOutlet="airportSubOption; context: { place: placeInfo }"></ng-container>
  </ng-template>
  <div class="searchInputAutocomplete__autocomplete-city-code">
    <app-ds-typography
      [text]="placeInfo.code"
      [size]="fontSize.XS"
      [color]="fontColor">
    </app-ds-typography>
  </div>
</ng-template>

<ng-template #cityPlaceTemplate let-place=" place" let-isBold="isBold">
  <div class="searchInputAutocomplete__autocomplete-place-info">
    <div class="searchInputAutocomplete__autocomplete-place-info-city">
      <app-ds-typography
        [text]="cityAutocompleteLabel(place)"
        [fontFamily]="isBold ? fontFamily.SemiBold : fontFamily.Regular"
        [size]="fontSize.XXS"
        [ellipsis]="true"
        [color]="fontColor">
      </app-ds-typography>
    </div>
    <div class="searchInputAutocomplete__autocomplete-place-info-airport">
      <app-ds-typography
        [text]="
          !mergeAirportsAndCities ? cityAutocompleteDescription(place) : (
            viewAllAirports(place | placeAirports: cityAndAirportsAutocomplete.airports) ? 
              ('SEARCH_MODULE.ALL_AIRPORTS' | transloco) :
                (place | placeAirports: cityAndAirportsAutocomplete.airports)[0]?.description
          )
        "
        [size]="fontSize.XXXS"
        [ellipsis]="true"
        [color]="fontColor">
      </app-ds-typography>
    </div>
  </div>
  <div class="searchInputAutocomplete__autocomplete-city-code">
    <app-ds-typography
      [text]="place.code"
      [size]="fontSize.XS"
      [color]="fontColor">
    </app-ds-typography>
  </div>
</ng-template>

<ng-template #airportSubOption let-place='place'>
  <div class="searchInputAutocomplete__autocomplete-place-info">
    <div class="searchInputAutocomplete__autocomplete-place-info-sub-airport">
      <div class="searchInputAutocomplete__autocomplete-place-info-sub-airport-icon">
        <ng-container *ngIf="useIconInSubdirectories">
          <app-ds-icon
            [icon]="icons.ArrowDerivated"
            [size]="22"
            [color]="iconFillColor.Tertiary">
          </app-ds-icon>
        </ng-container>
      </div>
      <div class="searchInputAutocomplete__autocomplete-place-info-sub-airport-airport-detail">
        <app-ds-typography
          [text]="place.description"
          [size]="fontSize.XXS"
          [fontFamily]="fontFamily.Regular"
          [ellipsis]="true"
          [color]="fontColor">
        </app-ds-typography>
        <app-ds-typography
          [text]="place.related_city + ', ' + place.country"
          [size]="fontSize.XXXS"
          [ellipsis]="true"
          [color]="fontColor">
        </app-ds-typography>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mergeAirportsAndCitiesTemplate>
  <ul class="searchInputAutocomplete__autocomplete-locations">
    <li *ngFor="let place of cityAndAirportsAutocomplete.cities; index as placeId">
      <div class="autocomplete-flex-cont" (click)="selectAirportOrCity(place)">
        <ng-container *ngTemplateOutlet="cityCardInfo; context: { place: place, icon: icons.Flights, isBold: true }"></ng-container>
      </div>
      @if (cityHasMultipleAirports(place | placeAirports: cityAndAirportsAutocomplete.airports)) {
        <ng-container *ngFor="let airportPlace of place | placeAirports: cityAndAirportsAutocomplete.airports; index as airportPlaceId;">
          <div class="autocomplete-flex-cont" (click)="selectAirportOrCity(airportPlace, true)">
            <div class="searchInputAutocomplete__autocomplete-airports" (click)="selectAirportOrCity(airportPlace, true)">
              <ng-container *ngTemplateOutlet="airportPlaceTemplate; context: { placeInfo: airportPlace, inCity: true }"></ng-container>
            </div>
          </div>
        </ng-container>
      }
    </li>
    <li *ngFor="let place of (cityAndAirportsAutocomplete.cities | airportsVm: cityAndAirportsAutocomplete.airports); index as placeId">
      <div class="autocomplete-flex-cont" (click)="selectAirportOrCity(place, true)">
        <ng-container *ngTemplateOutlet="airportCardInfo; context: { place: place, icon: icons.Flights, isBold: true }"></ng-container>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #loader>
  <div class="dsLoader__cont">
    <app-ds-loader-ring
      [type]="loaderRingType">
    </app-ds-loader-ring>
  </div>
</ng-template>

<ng-template #collapsableControl let-type="type">
  @if (isShowToggleVisible(type)) {
    <li class="searchInputAutocomplete__autocomplete-show-more" (click)="toggleVisibility(type)">
      <app-ds-typography
        [text]="(getShowAll(type) ? 'SEE_LESS' : 'SEE_MORE') | transloco"
        [fontFamily]="fontFamily.Regular"
        [size]="fontSize.XXS"
        [color]="fontColor">
      </app-ds-typography>
    </li>
  }
</ng-template>
